import { createFeatureSelector, createSelector } from "@ngrx/store";
import { NetworkState } from "./network.state";

export const selectNetworkState =
  createFeatureSelector<NetworkState>("network");

export const selectConnected = createSelector(
  selectNetworkState,
  (state: NetworkState) => state.isConnected,
);

export const selectSlow = createSelector(
  selectNetworkState,
  (state: NetworkState) => state.isSlow,
);

export const selectNotResponsive = createSelector(
    selectNetworkState,
    (state: NetworkState) => state.isNoResponse,
);

export const selectReconnected = createSelector(
    selectNetworkState,
    (state: NetworkState) => state.isConnected && !state.previousConnectedValue,
);

export const selectNetworkReady = createSelector(
    selectNetworkState,
    (state: NetworkState) => state.allSocketsConnected
)

export const selectConnectedSocketNamespaces = createSelector(
    selectNetworkState,
    (state: NetworkState) => state.sockets
)


export const selectNetworkEnabled = createSelector(
    selectNetworkState,
    (state: NetworkState) => state.networkEnabled
)
